import React from 'react';
import { Container } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import StripeFormContainer from '../containers/StripeFormContainer';
import i18n from '../utils/i18n';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import { MONTHS } from '../utils/constants';
import { getNumberWithSuffix } from '../utils/other';
import './styles/SubscriptionScreen.scss';

class SubscriptionPage extends React.Component {
  static getNextPaymentDate(nextPaymentIn) {
    const date = new Date();
    date.setDate(date.getDate() + nextPaymentIn);
    return date;
  }

  render() {
    const trialDays = this.props.config && this.props.config.stripe_trial_days;
    const nextPaymentDate = SubscriptionPage.getNextPaymentDate(trialDays || 0);

    return (
      <HeaderContainerTemplate>
        <Container>
          <div className="subscription">
            <div className="text">
              <h2>
                {i18n.t('payments.BUY_A_SUBSCRIPTION')}
              </h2>
              {trialDays ? (
                <div className="trial-info">
                  {i18n.t('payments.WILL_NOT_BE_CHARGED')}
                  {' '}
                  <i>
                    {MONTHS[nextPaymentDate.getMonth()]}
                    {' '}
                    {getNumberWithSuffix(nextPaymentDate.getDate())}
                  </i>
                  {', '}
                  {i18n.t('payments.WILL_SEND_AN_REMINDER_EMAIL')}
                </div>
              ) : (
                <span>
                  {i18n.t('payments.PREPARING_PAYMENT')}
                </span>
              )}
            </div>
            <div className="text">
              {i18n.t('payments.DURING_FREE_TRIAL')}
            </div>
            <div className="text">
              <strong>
                {i18n.t('payments.PRICE')}
              </strong>
            </div>
            <hr />
            <StripeFormContainer />
          </div>
        </Container>
      </HeaderContainerTemplate>
    );
  }
}

SubscriptionPage.propTypes = {
  config: PropTypes.shape({
    stripe_trial_days: PropTypes.number
  })
};

SubscriptionPage.defaultProps = {
  config: {
    stripe_trial_days: null
  }
};

const mapStateToProps = state => ({
  config: state.config.data
});

export default connect(
  mapStateToProps,
  null
)(SubscriptionPage);



// WEBPACK FOOTER //
// ./src/scenes/Subscription.js